const base = "cui-image-lc9q";
const classes = {
  base
};
export {
  base,
  classes as default
};
